import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostUpdateGive = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_GIVE_JACKPOT
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateGive as SetPostUpdateGive
}